// local
import { sharedRaceFile } from './shared-races.js';
// packages

import { createFeed, createSingleRaceFeed } from './stores.js';

import {
  renderSvelteComponent,
  findElementInShadowDom,
  findElementByIdInShadowDom,
} from './utils/render.js';

// components
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';

const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  // [id, source] for the shared L.A. races: follows scripts/shared-races.js
  const sheriff = sharedRaceFile('CA-84304');
  const mayor = sharedRaceFile('CA-84303');

  const [shfeed, mayorfeed] = await Promise.all([
    createSingleRaceFeed(...sheriff),
    createSingleRaceFeed(...mayor),
  ]);

  const atAGlanceRaces = [
    {
      id: sheriff[0],
      label: 'L.A. County Sheriff',
      feed: shfeed,
    },
    {
      id: mayor[0],
      label: 'L.A. Mayor',
      feed: mayorfeed,
    },
  ];

  // Each feed is a per-race file (RACE_URL), so the feed already is the race
  atAGlanceRaces.forEach((/** @type {any} */ r) => {
    r['store'] = r['feed'];
  });

  let aagContainer = findElementByIdInShadowDom('aag-la-county');
  if (!aagContainer) return;

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */ (aagContainer),
    {
      feed: atAGlanceRaces,
      crosswalk,
      // 'primary' shows the primary-only lines (top two advance, leading
      // candidates); 'general' hides them
      cycle: 'general',
      // true to show "*"" next to incumbents, and "* Incumbent" in the legend
      showIncumbents: true,
    }
  );
}

main().catch(console.error);
